var styles = {"Container":"styles-module_Container__Jv3s7","Title":"styles-module_Title__K2-19","Text":"styles-module_Text__sUQz7","Icon":"styles-module_Icon__NiMzQ","Layout":"styles-module_Layout__r1haI"};

export { styles as default };
